import { Directive, ElementRef, Input, Output, EventEmitter, OnInit, OnDestroy } from "@angular/core";

declare let plupload: any;

export class UploadButtonCompleteResponse {
  ok: string;
  filename: string;
  resize?: string;
}

@Directive({
  selector: "[hkt-uploadbutton]",
})
export class UploadButtonDirective implements OnInit, OnDestroy {
  @Input("upload-url") uploadUrl: string;
  @Input("folder") folder: string;
  @Input("filename") filename: string;
  @Input("max-file-size") maxFileSize: string;
  @Input("extensions") extensions: string;
  @Input("chunk-size") chunkSize: string;
  @Output("progress") progressEmitter: EventEmitter<number>;
  @Output("complete") completeEmitter: EventEmitter<UploadButtonCompleteResponse>;
  @Output("error") errorEmitter: EventEmitter<string>;

  elementId: string;
  uploader: any;

  static idCount = 1;

  constructor(private elementRef: ElementRef) {
    this.progressEmitter = new EventEmitter();
    this.completeEmitter = new EventEmitter();
    this.errorEmitter = new EventEmitter();

    if (this.elementRef.nativeElement.id === "") {
      this.elementId = "hkt-uploadbutton-" + UploadButtonDirective.idCount;
      this.elementRef.nativeElement.id = this.elementId;
      UploadButtonDirective.idCount++;
    } else {
      this.elementId = this.elementRef.nativeElement.id;
    }

    this.uploadUrl = "";
    this.folder = "";
    this.filename = "";
    this.maxFileSize = "1000mb";
    this.extensions = "";
    this.chunkSize = "5mb";
  }

  ngOnInit(): void {
    if (!this.uploadUrl) {
      console.error("Set upload-url");
      return;
    }

    let mime_types = [];
    let split_ext = this.extensions.split("#");
    for (let i = 0; i < split_ext.length; i++) {
      let split_type = split_ext[i].split("|");
      if (split_type.length == 1 && split_type[0].length > 0) {
        mime_types.push({ title: "Files Type", extensions: split_type[0] });
      } else if (split_type.length == 2 && split_type[1].length > 0) {
        mime_types.push({ title: split_type[0], extensions: split_type[1] });
      }
    }

    let options: any = {
      runtimes: "html5,flash,silverlight,html4",
      browse_button: this.elementId,
      url: this.uploadUrl,
      filters: {
        max_file_size: this.maxFileSize,
        mime_types: mime_types,
      },
      multipart_params: {
        folder: this.folder,
      },
      chunk_size: this.chunkSize,
      max_retries: 3,
      multi_selection: false,
      flash_swf_url: "../../assets/Moxie.swf",
      silverlight_xap_url: "../../assets/Moxie.xap",
    };
    if (this.filename !== "") {
      options.multipart_params.name = this.filename;
    }

    this.uploader = new plupload.Uploader(options);
    this.uploader.bind("FilesAdded", (up, files) => {
      this.uploader.disableBrowse(true);
      this.progressEmitter.emit(0);
      this.uploader.start();
    });
    this.uploader.bind("UploadProgress", (up, file) => {
      this.progressEmitter.emit(file.percent);
    });
    this.uploader.bind("FileUploaded", (up, file, response) => {
      this.uploader.disableBrowse(false);
      let responseData = JSON.parse(response.response);
      if (responseData.ok) {
        this.completeEmitter.emit(responseData);
      } else if (responseData.msg) {
        this.errorEmitter.emit(responseData.msg);
      } else {
        this.errorEmitter.emit("Error uploading file");
      }
    });
    this.uploader.bind("Error", (up, err) => {
      this.uploader.disableBrowse(false);
      this.errorEmitter.emit("Error uploading file");
    });
    this.uploader.init();
  }

  ngOnDestroy(): void {
    this.uploader.unbindAll();
    this.uploader.destroy();
  }
}
